"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactCollapse = require("react-collapse");
var _BaseLink = require("../BaseLink");
var _getRandomInt = _interopRequireDefault(require("../../utils/getRandomInt"));
var _isMobile = _interopRequireDefault(require("../../utils/isMobile"));
var _CssClassNames2 = _interopRequireDefault(require("../../scss/CssClassNames"));
var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));
var _excluded = ["dropdownClassName", "dropdownCollapseClassName", "subitems", "dropdown", "navbarShown", "onOpen", "onClose", "dropdownActive", "dropdownOn", "forceCloseDropdown"];
/* eslint-disable jsx-a11y/no-static-element-interactions */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var _CssClassNames = new _CssClassNames2["default"](_stylesModule["default"], ['utility', 'transition']),
  className = _CssClassNames.className;
var DropdownItem = function DropdownItem(_ref) {
  var dropdownClassName = _ref.dropdownClassName,
    dropdownCollapseClassName = _ref.dropdownCollapseClassName,
    _ref$subitems = _ref.subitems,
    subitems = _ref$subitems === void 0 ? [] : _ref$subitems,
    _ref$dropdown = _ref.dropdown,
    dropdown = _ref$dropdown === void 0 ? null : _ref$dropdown,
    _ref$navbarShown = _ref.navbarShown,
    navbarShown = _ref$navbarShown === void 0 ? false : _ref$navbarShown,
    _ref$onOpen = _ref.onOpen,
    onOpen = _ref$onOpen === void 0 ? null : _ref$onOpen,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? null : _ref$onClose,
    dropdownActive = _ref.dropdownActive,
    dropdownOn = _ref.dropdownOn,
    forceCloseDropdown = _ref.forceCloseDropdown,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFullyOpened = _useState4[0],
    setIsFullyOpened = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isFullyClosed = _useState6[0],
    setIsFullyClosed = _useState6[1];
  var id = (0, _react.useMemo)(function () {
    return (0, _getRandomInt["default"])('slb-');
  }, []);
  (0, _react.useEffect)(function () {
    if (!navbarShown && (0, _isMobile["default"])()) {
      setShow(false);
    }
  }, [navbarShown]);
  (0, _react.useEffect)(function () {
    if (show && onOpen) {
      onOpen(id);
    } else if (!show && onClose) {
      onClose(id);
    }
  }, [show, onOpen, onClose, id]);
  (0, _react.useEffect)(function () {
    if (dropdownActive && dropdownActive !== id) {
      setShow(false);
    }
  }, [dropdownActive, id, setShow]);
  (0, _react.useEffect)(function () {
    if (forceCloseDropdown && show) {
      setShow(false);
    }
  }, [forceCloseDropdown, show, setShow]);
  var handleToggleDropdown = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    setShow(show ? false : true);
  }, [show]);
  var handleEnter = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    setShow(true);
  }, []);
  var handleLeave = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    setShow(false);
  }, []);
  var handleOnWork = (0, _react.useCallback)(function (arg) {
    if (!arg.isOpened) {
      setIsFullyOpened(false);
    } else {
      setIsFullyClosed(false);
    }
  }, []);
  var handleOnRest = (0, _react.useCallback)(function (arg) {
    if (arg.isFullyOpened) {
      setIsFullyOpened(true);
    }
    if (arg.isFullyClosed) {
      setIsFullyClosed(true);
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (dropdownOn !== 'click') {
      return;
    }
    if (show) {
      setTimeout(function () {
        var overlay = window.document.getElementById('dropdown-overlay');
        if (overlay) {
          overlay.addEventListener('click', handleLeave);
        }
      }, 0);
    } else {
      var overlay = window.document.getElementById('dropdown-overlay');
      if (overlay) {
        overlay.removeEventListener('click', handleLeave);
      }
    }
  }, [show, dropdownOn, handleLeave]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    onMouseLeave: navbarShown || dropdownOn === 'click' ? function () {} : handleLeave
  }, /*#__PURE__*/_react["default"].createElement(_BaseLink.BaseLink, _extends({}, props, {
    id: id,
    onMouseEnter: dropdownOn === 'click' || navbarShown ? null : handleEnter,
    onClick: dropdownOn === 'click' || navbarShown ? handleToggleDropdown : null,
    role: "button",
    extraAttributes: _objectSpread(_objectSpread({}, props.extraAttributes && _objectSpread({}, props.extraAttributes)), {}, {
      'data-expanded': show,
      'aria-haspopup': 'true',
      'aria-expanded': show
    })
  })), subitems.length > 0 || dropdown ? /*#__PURE__*/_react["default"].createElement(_reactCollapse.Collapse, {
    isOpened: show,
    "aria-labelledby": id,
    onWork: handleOnWork,
    onRest: handleOnRest,
    theme: {
      collapse: className("".concat(dropdownCollapseClassName ? typeof dropdownCollapseClassName === 'string' ? dropdownCollapseClassName : dropdownCollapseClassName(show, isFullyClosed, isFullyOpened) : '', " dropdown-collapse")).className,
      content: className("".concat(dropdownClassName ? typeof dropdownClassName === 'string' ? dropdownClassName : dropdownClassName(show, isFullyClosed, isFullyOpened) : '', " dropdown")).className
    }
  }, dropdown ? dropdown : /*#__PURE__*/_react["default"].createElement("div", className('dropdown-items-wrapper'), subitems.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(_BaseLink.BaseLink, _extends({
      key: i
    }, className('dropdown-item', null, 'extraClassName'), item));
  }))) : null);
};
var _default = /*#__PURE__*/(0, _react.memo)(DropdownItem);
exports["default"] = _default;